// Export the desktop-only overlay
export const DesktopOnlyOverlay = () => {

    // Render the message
    return (

        <div className="desktop-only-overlay">

            <div className="desktop-only-overlay__content">

                <img src="https://www.strichsuite.com/images/thestrich.png" alt="StrichSuite"/>

                <br/>
                <br/>

                <h1>I can't fit!</h1>

                <p>

                    StrichSuite needs a wider browser window to display correctly.

                </p>

                <p>

                    Please enlarge your browser window
                    Or use a device with a screen width above 768 pixels.

                </p>

            </div>

        </div>

    );

};